import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { AuthorizeActions } from "../../authorize/actions";
import { StatusViewService } from "../../shared/services/status-view.service";
import { accessFunctions } from "../../shared/utilities/Constants";
import { AccessFunctionRequest } from "../models/access-function-request";

@Injectable()
export class AuthorizeEffects {
  constructor(
    private actions$: Actions,
    private statusViewService: StatusViewService
  ) {}

  authorize$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthorizeActions.authorize),
      switchMap((action) => { 
        let request: AccessFunctionRequest = {
          accessFunctions: []
        }
        action.authorizeRequest.forEach(x => {
          request.accessFunctions.push(x.accessFunction)
        });
        return this.statusViewService.authorize(request).pipe(
          map((response) => {
            return AuthorizeActions.authorizeSuccess({ accessFunctions: response })
          }),
          catchError((error) => {
            let mappedResponse: {[key: string]: boolean} = {};
            action.authorizeRequest.forEach(x => {
              mappedResponse[x.accessFunction] = x.defaultTo;
            });
            return of(AuthorizeActions.authorizeFailed({
              errorMessage: error,
              accessFunctions: mappedResponse
            }))
          })
        )}
      )
    )
  )
}